export default __webpack_public_path__ + "static/media/410.464c16ba.png";